import { useCallback, useRef } from 'react';

import { useLocalStorage } from 'react-use';

import { EnumOpenDialog } from '../stores/ui/types';
import { useStores } from '../stores/useStores';

const MISSED_WELCOME_BONUS_KEY = 'missed_welcome_bonus';

export function useMissedWelcomeBonus() {
  const {
    uiStore,
    rewardsStore,
    userStore: { profile },
  } = useStores();

  const [missedWelcomeBonusData, setMissedWelcomeBonusUserData, removeMissedWelcomeBonusUserData] =
    useLocalStorage<null | { userId: string }>(MISSED_WELCOME_BONUS_KEY, null);

  const isWelcomeBonusAlreadyShowed = useRef(false);

  const checkWelcomeBonusMissed = useCallback(() => {
    if (isWelcomeBonusAlreadyShowed.current) {
      return false;
    }

    if (!missedWelcomeBonusData) {
      isWelcomeBonusAlreadyShowed.current = true;
      return false;
    }

    try {
      const { userId } = missedWelcomeBonusData;

      if (!profile || profile.firebaseUid !== userId) {
        return false;
      }

      if (rewardsStore.welcomeBonus) {
        return true;
      }

      return false;
    } catch (error) {
      removeMissedWelcomeBonusUserData();
      return false;
    }
  }, [rewardsStore, missedWelcomeBonusData, profile, removeMissedWelcomeBonusUserData]);

  const showWelcomeBonusDialog = useCallback(() => {
    if (rewardsStore.welcomeBonus) {
      uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenWelcomeBonusDialog });

      isWelcomeBonusAlreadyShowed.current = true;
    }
  }, [uiStore, rewardsStore]);

  return {
    showWelcomeBonusDialog,
    checkWelcomeBonusMissed,
    setMissedWelcomeBonusUserData,
    removeMissedWelcomeBonusUserData,
  };
}
